module.exports = __webpack_public_path__ + "img/mbb.151ab128.png";